module.exports = __webpack_public_path__ + "static/media/twitter.91f6324f.png";